import GalleryList from "../components/GalleryList";

const ListGalleryPage = () => {
  return (
    <GalleryList />
  );
};

export default ListGalleryPage;
